import { Box } from '@mui/material';
import React from 'react';
import uniquexLogo from "../../assets/svgs/RL-BrandMark.svg";
import uniquexLogoFull from '../../assets/svgs/lg-RL-Tagline.svg';
import splashScreenBgImg from '../../assets/images/splashScreenBgImg.png';
import RosetaLive from '../../assets/svgs/rosetaLive.svg';

interface SplashScreenProps {
  fadingOut: boolean; // To control the fade-out effect
}

const SplashScreen: React.FC<SplashScreenProps> = ({ fadingOut }) => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100vh"
      width='100wh'
      flexDirection="column"
      sx={{
        backgroundImage: `url(${splashScreenBgImg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        opacity: fadingOut ? 0 : 1,
        transition: 'opacity 0.5s ease',
        animation: `${fadingOut ? '' : 'zoomDarken'} 3s ease forwards`,
        overflow: 'hidden',
      }}
    >
<Box>
  <Box
    component="img"
    src={uniquexLogo}
    alt="UniqueX"
    sx={{
      width: { xs: 40, sm: 80 },
      height: { xs: 40, sm: 80 },
    }}
  />
  <Box
    component="img"
    src={RosetaLive}
    alt="Rosetta Live"
    sx={{
      width: { xs: 180, sm: 430 },
      height: { xs: 40, sm: 80 },
      animation: `${fadingOut ? '' : 'slideInFromRight'} 2s ease forwards`,
    }}
  />
</Box>
</Box>


  );
};

// Define the keyframes for the animations
const styles = `

@keyframes zoomDarken {
  0% {
    filter: brightness(1.2);
  }
  100% {
    filter: brightness(1); 
  }
}

@keyframes slideInFromRight {
  0% {
    transform: translateX(100%);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}`;

// Add the styles to the document's head
const styleSheet = document.createElement('style');
styleSheet.type = 'text/css';
styleSheet.innerText = styles;
document.head.appendChild(styleSheet);

export default SplashScreen;
